import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export function useDeleteAdviceMaintenance() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<void, Error, string>({
		mutationFn: async (adviceId) => {
			try {
				await api.delete(`/advices/fertilization-plan/delete/${adviceId}`, {
					params: { forBinding },
				});
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir a recomendação de manutenção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['maintenance'] });
		},
	});
}
